import { useTranslate } from '@ur-solutions/react-hooks'
import { Checkbox } from '@/components_deprecated'
import type { FilterChildren } from '@/components_deprecated/FilterPopup'
import { FilterPopup } from '@/components_deprecated/FilterPopup'
import {
  Status,
  StatusButton,
} from '@/components_deprecated/FilterPopup/components'
import type { VehicleFilter } from '@/modules/vehicles/types'
import styled from 'styled-components'
import ScrollBar from 'react-perfect-scrollbar'

export const CustomScrollBar = styled(ScrollBar)`
  max-height: 200px;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  align-items: flex-start;
`
interface FleetFilterProps extends FilterChildren<VehicleFilter> {
  vehicleTypes: string[]
}

export const FleetFilter: React.FC<FleetFilterProps> = ({
  filter,
  vehicleTypes,
  onUpdate,
}) => {
  const translations = useTranslate({
    status: 'common.status',
    archived: 'common.archived',
    type: 'common.type',

    both: 'common.both',
    open: 'common.open-alt',
    closed: 'common.closed',

    owned: 'vehicles.owned',
    unowned: 'vehicles.unowned',
  })

  function toggleOwned(owned: boolean) {
    return () =>
      onUpdate({
        owned,
      })
  }

  function toggleType(type: string, checked: boolean) {
    let newIncludedTypes = [...filter.includedTypes]

    if (checked) {
      if (!newIncludedTypes.includes(type)) {
        newIncludedTypes.push(type)
      }
    } else {
      newIncludedTypes = newIncludedTypes.filter(t => t !== type)
    }

    onUpdate({ includedTypes: newIncludedTypes })
  }

  return (
    <FilterPopup>
      <h4>{translations.owned}</h4>
      <Status statusCount={2}>
        <StatusButton active={!!filter.owned} onClick={toggleOwned(true)}>
          {translations.owned}
        </StatusButton>
        <StatusButton active={!filter.owned} onClick={toggleOwned(false)}>
          {translations.unowned}
        </StatusButton>
      </Status>

      <h4>{translations.type}</h4>
      <CustomScrollBar
        options={{
          suppressScrollY: vehicleTypes.length < 6,
        }}
      >
        {vehicleTypes.map(vehicle => {
          const checked = filter.includedTypes.includes(vehicle)
          return (
            <Checkbox
              key={vehicle}
              checked={checked}
              label={vehicle}
              boxWidth="32px"
              boxHeight="32px"
              fontSize="1rem"
              onChange={check => toggleType(vehicle, check)}
            />
          )
        })}
      </CustomScrollBar>
    </FilterPopup>
  )
}
